import {delay} from 'redux-saga';
import {all, call, put, select, takeEvery} from 'redux-saga/effects';
import cookies from 'core/cookies';
import uuidv4 from 'uuid/v4';
import moment from 'moment';
import 'moment-timezone';

import * as action from '../actions';
import * as selector from '../selectors';
import * as dataContext from '../dataProvider/dataContext';

function* readySaga() {
	yield put(action.ready());
}

function* loadSettings() {
	try {
		const response = yield call(dataContext.getSettings);
		yield put(action.loadSettings.success({data: response}));
	} catch (err) {
		yield put(action.loadSettings.failure());
		//yield put(notify.error(err.data && err.data.message || 'Произошла ошибка', 'Ошибка'));
	}
}

function* uuidSaga() {
	// uuid
	let uuid = cookies.get('uuid');
	if (!uuid) {
		uuid = uuidv4();
		cookies.set('uuid', uuid);
	}
	yield put(action.uuid({uuid}));
}

function* momentSaga() {
	const {timezone, midnight} = yield select(selector.getSettings);
	// update moment instance every minute
	while (true) {
		const momentTimezone = moment.tz(timezone);
		const momentTimezoneOffset = momentTimezone.clone().subtract({hours: midnight});
		yield put(action.moment({momentTimezone, momentTimezoneOffset}));
		yield delay(60000);
	}
}

export default function* sagas() {
	yield all([
		takeEvery(action.loadSettings.request, loadSettings),
		takeEvery(action.loadSettings.success, readySaga),
		takeEvery(action.ready, uuidSaga),
		takeEvery(action.ready, momentSaga),
	]);
}



// WEBPACK FOOTER //
// ./src/sagas/appSaga.js